import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { RouteProps, Redirect, useLocation } from 'react-router-dom';
import { HTTP_STATUS } from '../../config/api';
import { NOT_FOUND_PATH } from '../../config/routes/paths';
import { IAuthContext, useAuth } from '../../lib/context-providers/auth-context';
import LoginWrapper from "./LoginWrapper/LoginWrapper";
import { useEventPublicInfo } from '../../hooks/api/public/use-event-public-details';
import { LoadingPage } from './LoadingPage';
import { CODE, PLAYER_ONLY, STATE, SUBSCRIBE_TO_EVENT, TOKEN } from '../../lib/constants';

export const PassportPlaceholder: React.FC<RouteProps> = (props: RouteProps): JSX.Element | null => {
  const { isValidating, error, data } = useEventPublicInfo();
  const auth = useAuth() as IAuthContext;

  const history = useHistory();
  const { state, search } = useLocation<{ from?: string }>();
  const params = new URLSearchParams(window.location.search);
  const token = params.get(TOKEN);
  const code = params.get(CODE);
  const userState = params.get(STATE);

  useEffect(() => {
    if (state?.from && auth?.isAuthenticated && search?.includes(PLAYER_ONLY)) {
      history.replace({ pathname: state.from, search });
    } else if (state?.from && auth?.isAuthenticated) {
      history.replace(state.from);
    } else if (auth?.isAuthenticated && search?.includes(SUBSCRIBE_TO_EVENT)) {
      history.replace(search);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, auth?.isAuthenticated]);

  const handleSignIn = async (email: string, code: string) => {
    const isAuthenticated = await auth.signIn(email, code, data?.attendeeSsoEnabled ?? false);
    if (state?.from && isAuthenticated) {
      history.replace(state.from);
    }
  };

  if (token || (code && userState)) {
    return <LoadingPage token={token} code={code} userState={userState} />;
  }

  if (error && error.status === HTTP_STATUS.NOT_FOUND) return <Redirect to={NOT_FOUND_PATH} />;
  if (!isValidating && data && auth.isAuthenticated === false) {
    return (
      <LoginWrapper
        data={data}
        signIn={(email, code) => handleSignIn(email, code)}
      />
    );
  }

  return null;
};